import React, { useState, useCallback } from 'react';
import { useScreenSize } from '../../../../../utils/media-query';
import { PopupForm } from '../../../../script/components/popup/popup';
import { FormDate, FormMemo, FormNumb, FormText } from '../../../../script/components/form/form-item';
import { GroupItem } from 'devextreme-react/cjs/form';
import { fwUtil } from '../../../../script/util';

const defaultData = {
    mana_numb: '',
    comp_seri: '',
    clie_code: '',
    clie_name: '',
    insp_kwon: 0,
    part_kwon: 0,
    bill_kwon: 0,
    pays_kwon: 0,
    bill_date: fwUtil.date.getsText.date(),
    pays_date: fwUtil.date.getsText.date(),
    asac_memo: '',
};

export function AserAccoChanUpdate(props) {
    const {
        mainGrid, 
        refresh,
        updateApi,
        visible, hiding
    } = props;

    const { isXSmall, isSmall } = useScreenSize();
    const [loading, setLoading] = useState(false);
    // 데이터
    const [data, setData] = useState(defaultData);
    const dataUpdate = useCallback((e) => setData(e), [setData]);

    // 열릴 때
    const onShowing = useCallback(async() => {
        const seleData = fwUtil.grid.get.sData(mainGrid);
        if (fwUtil.conv.check.nua(seleData)) {
            fwUtil.aler.toast.s1Erro();
            hiding();
        } else {
            const resData = {
                mana_numb: seleData.mana_numb || defaultData.mana_numb,
                comp_seri: seleData.comp_seri || defaultData.comp_seri,
                clie_code: seleData.clie_code || defaultData.clie_code,
                clie_name: seleData.clie_name || defaultData.clie_name,
                insp_kwon: seleData.insp_kwon || defaultData.insp_kwon,
                part_kwon: seleData.part_kwon || defaultData.part_kwon,
                bill_kwon: seleData.bill_kwon || defaultData.bill_kwon,
                pays_kwon: seleData.pays_kwon || defaultData.pays_kwon,
                bill_date: seleData.bill_date || defaultData.bill_date,
                pays_date: seleData.pays_date || defaultData.pays_date,
                asac_memo: seleData.asac_memo || defaultData.asac_memo,                
            };

            dataUpdate(resData);
        }
    }, [hiding, mainGrid, dataUpdate]);

    // 수정
    const updateField = (field) => (value) => {
        if (!data) return;

        dataUpdate({ ...data, [field]: value });
    };

    // 제출
    const onSubmit = useCallback(async () => {
        setLoading(true);
        const postData = {
            manaNumb: data.mana_numb || defaultData.mana_numb,
            compSeri: data.comp_seri || defaultData.comp_seri,
            clieCode: data.clie_code || defaultData.clie_code,
            clieName: data.clie_name || defaultData.clie_name,
            inspKwon: data.insp_kwon || defaultData.insp_kwon,
            partKwon: data.part_kwon || defaultData.part_kwon,
            billKwon: data.bill_kwon || defaultData.bill_kwon,
            paysKwon: data.pays_kwon || defaultData.pays_kwon,
            billDate: data.bill_date ? fwUtil.date.convTime.fmDate(data.bill_date) : defaultData.bill_date,
            paysDate: data.pays_date ? fwUtil.date.convTime.fmDate(data.pays_date) : defaultData.pays_date,
            asacMemo: data.asac_memo || defaultData.asac_memo,            
        };

        await fwUtil.apis.action(updateApi, postData, refresh, hiding);
        setLoading(false);
    }, [data, updateApi, refresh, hiding]);

    return (
        <>        
        <PopupForm
            title={'A/S 정산 변경'}       
            type={'수정'}
            loading={loading}
            visible={visible}
            showing={onShowing}
            hiding={hiding}
            onSubmit={onSubmit}
            width={isXSmall || isSmall ? "100%" : 600}  
        >
            <GroupItem colCount={isXSmall ? 1 : 2}>
                {FormText({ value: data.mana_numb, onValueChange: updateField('mana_numb'), label: '관리번호', required: true, disabled: true })}
                {FormText({ value: data.comp_seri, onValueChange: updateField('comp_seri'), label: '정산순번', required: true, disabled: true })}
                {FormText({ value: data.clie_code, onValueChange: updateField('clie_code'), label: '고객번호', disabled: true })}
                {FormText({ value: data.clie_name, onValueChange: updateField('clie_name'), label: '고객명', disabled: true })}
                {FormNumb({ value: data.insp_kwon, onValueChange: updateField('insp_kwon'), label: '출장비', disabled: true })}
                {FormNumb({ value: data.part_kwon, onValueChange: updateField('part_kwon'), label: '부품비', disabled: true })}
                {FormDate({ value: data.bill_date, onValueChange: updateField('bill_date'), label: '청구일자', required: true })}
                {FormNumb({ value: data.bill_kwon, onValueChange: updateField('bill_kwon'), label: '청구금액', length: [15, 2] })}
                {FormDate({ value: data.pays_date, onValueChange: updateField('pays_date'), label: '정산일자' })}
                {FormNumb({ value: data.pays_kwon, onValueChange: updateField('pays_kwon'), label: '정산금액', length: [15, 2] })}
            </GroupItem>
            {FormMemo({ value: data.asac_memo, onValueChange: updateField('asac_memo'), label: '비고' })}
        </PopupForm>     
        </>
    );
}